module.exports = __webpack_public_path__ + "img/16m009-06.5fb6f57b.png";